import { useGetCompanyRolePermissionsMeQuery } from 'redux-store/api/company-roles';
import { DraftButtonWithDialog } from './components/draft-button-with-dialog';
import { useGetDraftsQuery } from 'redux-store/api/activity-feed';

export const Drafts = () => {
  const { data: userPermissions } = useGetCompanyRolePermissionsMeQuery();

  const hasAccess = userPermissions?.ENABLE_ACTIVITY_FEED?.canRead;

  const { data, isLoading, isError } = useGetDraftsQuery(undefined, { skip: !hasAccess });

  if (!data?.items.length || !hasAccess) return null;

  return <DraftButtonWithDialog data={data} isLoading={isLoading} isError={isError} />;
};
